import type { DocumentNode } from 'graphql'
import gql from 'graphql-tag'

const createSubscription: DocumentNode = gql`
  mutation createSubscription(
    $planCode: String!
    $currency: String!
    $email: EmailAddress!
    $accountCode: String!
    $couponCodes: [String]
    $trialEndsAt: DateTime
  ) {
    createSubscription(
      input: { planCode: $planCode, couponCodes: $couponCodes, currency: $currency, trialEndsAt: $trialEndsAt, account: { code: $accountCode, email: $email } }
    ) {
      ... on SubscriptionCreateResponse {
        currentTermEndsAt
        trialEndsAt
        id
        uuid
        plan {
          code
          name
        }
      }
      ... on SubscriptionCreateErrorNotFound {
        error {
          message
          params
          type
        }
      }
      ... on SubscriptionCreateErrorResponse {
        error {
          type
          message
          params
          transactionError {
            code
            message
            declineCode
            merchantAdvice
            transactionId
            threeDSecureActionTokenId
          }
        }
      }
    }
  }
`

export default createSubscription
